import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MdHealthAndSafety } from "react-icons/md";
import { FaGraduationCap } from "react-icons/fa";
import { FaEnvira } from "react-icons/fa";
import Api from '../function/axiosInterceptor';
let About = () => {
    const [about, setAbout] = useState({ what_we_do: [{ sno: '', title: '', content: '' }], banner: [{ sno: '', image: '' }] });
    const [data, setData] = useState({})
    const [donation, setDonation] = useState([])
    const fetchAbaout = async () => {
        try {
            const response = await Api.get('/abouts');
            if (response.status !== 'success') return
            setAbout(response.data);
        } catch (err) { }
    }
    const fetchAbaoutUser = async () => {
        try {
            const response = await Api.get('/user/abouts');
            if (response.status != 1) return
            setData(response?.data);
            setDonation(response?.donations);
        } catch (err) { }
    }
    useEffect(() => { fetchAbaout(); fetchAbaoutUser() }, [])
    return (
        <>
            <section>
                <div className="breadcrumb-area" style={{ backgroundImage: "url(" + process.env.REACT_APP_IMG_BASE_URL + "/img/" + about?.banner[0]?.image + ")" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="breadcrumb-inner">
                                    <h2 className="page-title">About Us</h2>
                                    <ul className="page-list">
                                        <li><Link to="/">Home</Link></li>
                                        <li><Link to="">About Us</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="about-area padding-top-115 padding-bottom-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="about-title-content margin-bottom-50">
                                    <div className="section-title desktop-left">
                                        <span>About Us</span>
                                        <h3 className="title">
                                            We Are In A Mission To
                                            Help The <span> Helpless
                                            </span>
                                        </h3>
                                    </div>
                                    <div className="section-paragraph">
                                        <p>
                                            <span>W</span>elcome to the MNB Foundation's exceptional world, where our constant trust in the power of unity drives our mission to effect significant change.
                                        </p>
                                        <p>
                                            In the face of tragedy and uncertainty, we remain strong and committed to offering timely solutions that answer our communities' pressing needs.
                                            Our undying commitment to improving lives is at the heart of our foundation.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="about-content-area padding-top-60 padding-bottom-60">
                            <div className="bg-img" style={{ backgroundImage: "url(/main/files/static/about1.jpg)" }}></div>
                            <div className="row">
                                <div className="col-lg-7 offset-lg-5">
                                    <div className="about-content">
                                        <div className="section-title">
                                            <p>We recognize that many individuals and families are dealing with difficult situations that compromise their well-being. That is why we focus our efforts on initiatives that have a significant impact on people who need it the most.</p>
                                            <p>We start on a quest to promote positive change and improve society's most disadvantaged members through our appealing charity fundraising activities. When you donate to our cause, you help to provide important resources, essential services, and life-changing opportunities to individuals in need. We can construct a route to success for persons confronting problems, encouraging them to overcome hurdles and achieve success.
                                            </p>
                                            <p>
                                                Our Foundation is built on transparency and accountability. We hold ourselves to the highest standards, ensuring that every donation is used properly and efficiently, with the greatest possible impact on the ground. Your generous donation will go directly to programs that address essential issues including education, healthcare, reducing hunger, and environmental sustainability.
                                            </p>
                                        </div>
                                        <div className="content">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="problem-area padding-top-90 padding-bottom-50" >
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-sm-11 col-11">
                                <div className="section-title b-top desktop-center padding-top-25 margin-bottom-55">
                                    <span>What we do</span>
                                    <h2 className="title">
                                        We have chosen the following issues.
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-lg-4 col-md-6">
                                <div className="problem-single-item margin-bottom-30">
                                    <div className="icon">
                                        <MdHealthAndSafety />
                                    </div>
                                    <div className="content">
                                        <h4 className="title">
                                            <Link href>{about?.what_we_do[0]?.title}</Link>
                                        </h4>
                                        <p><div className="Container" dangerouslySetInnerHTML={{ __html: about?.what_we_do[0]?.content }}></div><br /><br /><br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="problem-single-item margin-bottom-30">
                                    <div className="icon style-01">
                                        <FaGraduationCap />
                                    </div>
                                    <div className="content">
                                        <h4 className="title">
                                            <Link href="">{about?.what_we_do[1]?.title}</Link>
                                        </h4>
                                        <p><div className="Container" dangerouslySetInnerHTML={{ __html: about?.what_we_do[1]?.content }}></div><br /> <br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="problem-single-item margin-bottom-30">
                                    <div className="icon style-02">
                                        <FaEnvira />
                                    </div>
                                    <div className="content">
                                        <h4 className="title">
                                            <Link href="">{about?.what_we_do[2]?.title}</Link>
                                        </h4>
                                        <p><div className="Container" dangerouslySetInnerHTML={{ __html: about?.what_we_do[2]?.content }}></div></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            data?.userId ? <>
                                <div class="row" >
                                    <div class="col-sm-6 col-xl-3">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0 me-3">
                                                        <div class="avatar-sm">
                                                            <span class="avatar-title bg-primary-lighten text-primary rounded">

                                                                <i class="bi bi-patch-check-fill font-24"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <h6 class="mt-0 mb-1">Total Contribution</h6>
                                                        <p class="mb-0">₹{Number(data?.totalDonation || 0).toFixed(2)}</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 col-xl-3">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0 me-3">
                                                        <div class="avatar-sm">
                                                            <span class="avatar-title bg-success-lighten text-success rounded">

                                                                <i class="bi bi-check2-all font-24"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <h6 class="mt-0 mb-1">Approved Contribution</h6>
                                                        <p class="mb-0">₹{Number(data?.approvedDonation || 0).toFixed(2)}</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 col-xl-3">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0 me-3">
                                                        <div class="avatar-sm">
                                                            <span class="avatar-title bg-info-lighten text-info rounded">
                                                                <i class="bi bi-stopwatch-fill font-24"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <h6 class="mt-0 mb-1">Pending Contribution</h6>
                                                        <p class="mb-0">₹{Number(data?.pendingDonation || 0).toFixed(2)}</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 col-xl-3">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0 me-3">
                                                        <div class="avatar-sm">
                                                            <span class="avatar-title bg-warning-lighten text-warning rounded">
                                                                <i class="bi bi-x-lg font-24"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <h6 class="mt-0 mb-1">Rejected Contribution</h6>
                                                        <p class="mb-0">₹{Number(data?.rejectDonation || 0).toFixed(2)}</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" >
                                    <div class="col-md-9">
                                        <table class="table table-bordered table-striped" >
                                            <thead>
                                                <tr className='table-primary'>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Email</th>
                                                    <th scope="col">Donation Amount</th>
                                                    <th scope="col">Date</th>
                                                    <th scope="col">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    (donation || []).map(row => (<tr className='justify-content-between align-items-center'>
                                                        <th scope="row">1</th>
                                                        <td>{row.name}</td>
                                                        <td>{row.email}</td>
                                                        <td>₹{Number(row.amount || 0).toFixed(2)}</td>
                                                        <td>{new Date(row?.donation_date).toDateString()}</td>
                                                        <td><spam class={row?.status == 1 ? "text-success" : row?.status == 2 ? "text-danger" : "text-info"}>{row?.status == 1 ? 'verified' : row?.status == 2 ? 'Rejected' : 'Pending'}</spam></td>
                                                    </tr>))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="col-md-3">

                                        <div class="card">
                                            <div class="card-header d-flex justify-content-between align-items-center">
                                                <h6 class="header-title mb-0">Volunteer Profile Section</h6>

                                            </div>
                                            <div class="card-body">
                                                <img src="https://img.freepik.com/premium-photo/happy-man-ai-generated-portrait-user-profile_1119669-1.jpg" class="rounded-circle avatar-lg img-thumbnail m-auto" alt="profile-image" width={100} />

                                                <h5 class="mb-0 mt-2">{data?.name}</h5>
                                                <small class="text-muted font-14">Volunteer ID : MNBF{data.userId}</small>

                                                <button type="button" class="btn btn-success btn-sm mb-2">View Details</button>
                                                <button type="button" class="btn btn-danger btn-sm mb-2" data-bs-toggle="modal" data-bs-target="#volunteerLogins">ID Card</button>

                                                <div class="text-start mt-3">

                                                    <p class="text-muted mb-2 font-13"><strong>Joined Date :</strong> <span class="ms-2">{new Date(data?.createdAt).toDateString()}</span></p>
                                                    <p class="text-muted mb-2 font-13"><strong>Email ID :</strong> <span class="ms-2">{data?.email}</span></p>
                                                    <p class="text-muted mb-2 font-13"><strong>Phone No :</strong> <span class="ms-2">{data?.phone}</span></p>

                                                </div>

                                                <ul class="social-list list-inline mt-3 mb-0">
                                                    <li class="list-inline-item">
                                                        <a href="javascript: void(0);" class="social-list-item border-primary text-primary"><i class="mdi mdi-facebook"></i></a>
                                                    </li>
                                                    <li class="list-inline-item">
                                                        <a href="javascript: void(0);" class="social-list-item border-danger text-danger"><i class="mdi mdi-google"></i></a>
                                                    </li>
                                                    <li class="list-inline-item">
                                                        <a href="javascript: void(0);" class="social-list-item border-info text-info"><i class="mdi mdi-twitter"></i></a>
                                                    </li>
                                                    <li class="list-inline-item">
                                                        <a href="javascript: void(0);" class="social-list-item border-secondary text-secondary"><i class="mdi mdi-github"></i></a>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div class="card-body pt-1">


                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </> : ''
                        }

                    </div>
                </section>


                <div className="work-towards-area bg-image padding-bottom-80 padding-top-80" style={{ backgroundImage: "url(/main/files/static/join.jpg)" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="left-content">
                                    <div className="inner-section-title desktop-center">
                                        <h2 className="title">
                                            Join the community to give
                                            education for children
                                        </h2>
                                        <div className="btn-wrapper margin-top-30">
                                            <Link to="#" className="boxed-btn reverse-color"><span>Join Our Community</span></Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="our-latest-area padding-bottom-90 padding-top-90">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-8 col-lg-12">
                                <div className="help-and-support-left">
                                    <div className="section-title margin-bottom-35">
                                        <h2 className="title">
                                            Save a life. Donate to  <span>MNB Foundation</span>
                                        </h2>
                                        <p>
                                            MNB FOUNDATION goes above and above to make a significant difference in the areas that we serve. Here's what differentiates and separates us:
                                        </p>
                                        <p>
                                            1. <strong>
                                                Holistic Approach:
                                            </strong> To address the various needs of individuals and communities, we take a thorough and  holistic approach. We recognize that addressing issues from multiple perspectives, such as healthcare, education, livelihood, and social empowerment, is necessary for long-term transformation.
                                        </p>
                                        <p>
                                            2. <strong>
                                                Collaboration and Partnerships:
                                            </strong> We believe in the power of teamwork. We optimize our collective effect by forming strategic collaborations with like-minded groups, governments, and stakeholders. We pool our resources, knowledge, and skills to achieve better results and help more people in need.
                                        </p>
                                        <p>
                                            3. <strong>
                                                Innovative Solutions:
                                            </strong> We are committed to developing novel solutions to complicated problems. We aspire to develop and implement advanced programs and projects that offer tangible outcomes through research, technology, and continual learning. In our effort to make a lasting change, we are continually pushing limits and exploring new possibilities.
                                        </p>

                                        <p>
                                            4. <span>Transparent and Accountable:</span> We take pleasure in our honesty and accountability. We realize the importance of resource management and make certain that every dollar donated to MNB FOUNDATION is used properly and effectively. We provide our stakeholders with regular updates, reports, and financial disclosures, providing complete openness in our operations.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-12">
                                <div className="help-and-support-right bg-image padding-top-20">
                                    <img src="/main/files/static/heands.jpg" style={{ borderRadius: "15px" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="problem-area padding-top-80 padding-bottom-80">
                    <div className="bg-img" style={{ backgroundImage: "url(/main/files/static/about1.jpg)" }}></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 offset-lg-4">
                                <div className="problem-area-wrapper">
                                    <div className="row">
                                        <div className="col-lg-12 col-sm-11 col-11">
                                            <div className="section-title margin-bottom-55">
                                                <span>
                                                    Our Mission
                                                </span>
                                                <h2 className="title">
                                                    Providing Access to <span>Healthcare</span> for a Healthier Today and a Brighter Tomorrow.
                                                </h2>
                                                <p>
                                                    Our purpose at MNB FOUNDATION is to enhance people's lives via compassionate and innovative solutions. We work to empower individuals, particularly those experiencing socioeconomic hardships, by giving them the resources, opportunities, and support systems they require. Our mission is to help people live satisfying lives, reach their full potential, and constructively contribute to society.
                                                </p>
                                                <div className="btn-wrapper margin-top-30">
                                                    <Link to="#" className="boxed-btn reverse-color"><span>Donate Now</span></Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>

            <div class="modal fade" id="volunteerLogins" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg ">
                    <div class="modal-content">
                        <div class="modal-header no-print">
                            <h5 class="modal-title" id="exampleModalLabel">Volunteer ID Card</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="id-wrapper p-0">


                                <div class="id-card-vertical">
                                    <div class="id-header">
                                        <img src="https://mnbfoundation.com/api/img/6122023_9950917.png" class="w-100" style={{ maxWidth: "180px" }} />
                                    </div>

                                    <div class="profile-photo">
                                        <img src="https://img.freepik.com/premium-photo/happy-man-ai-generated-portrait-user-profile_1119669-1.jpg" alt="Employee Photo" />
                                    </div>

                                    <div class="id-info mb-1">
                                        <h5 className='mb-0'>Kundan</h5>
                                        <p className='my-0'>Volunteer</p>
                                        <p className='my-0'><span class="label">Volunteer ID:</span> MNBF{data?.userId}</p>
                                        <div class="details-box mt-0">
                                            <p className='my-0'><span class="label">Phone:</span> {data?.phone}</p>
                                            <p className='my-0'><span class="label">Email:</span> {data?.email}</p>
                                        </div>
                                    </div>

                                    <div class="id-footer">
                                        <span>{data?.dob?new Date(data?.dob).toDateString():''}</span>
                                        <div class="signature-box"></div>
                                    </div>
                                </div>


                                <div class="id-card-vertical">
                                    <div class="id-header">
                                        <h6>SCAN &amp; VERIFY</h6>
                                    </div>

                                    <div class="d-flex justify-content-center p-3">
                                        <div class="rounded">
                                            <img src="/main/files/static/webqr.png" class="w-100" />
                                        </div>
                                    </div>

                                    <div class="px-3 text-center" >
                                        <p className='my-0'>If found, please contact:</p>
                                        <p className='my-0 fw-semibold'>MNB Foundation</p>
                                        <p className='my-0' >G-75, 2nd Floor, Sector 63, Noida, Uttar Pradesh 201301.</p>
                                        <p className='my-0'>+91 9311 221776</p>
                                    </div>

                                    <div class="id-footer">
                                        <small>Official Use Only</small>
                                        <small>ID Protected</small>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="modal-footer no-print">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary">Print</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default About;